import Vue from 'vue'
import { dictList } from '@/utils/dict'
import { baseApi } from '@/api/baseApi.js'
import { appealApi } from '@/api/appealApi.js'
import { accountInfoApi } from '@/api/accountInfoApi.js'

// 设置表格高度
Vue.prototype.$setTableHeight = function () {
  const getComputedMargin = function (ele) {
    const computedStyle = getComputedStyle(ele)
    const top = parseInt(computedStyle.marginTop)
    const bottom = parseInt(computedStyle.marginBottom)
    const height = ele.offsetHeight
    return top + height + bottom
  }
  const container = this.$refs['containerCom']
  if (!container) {
    return
  }
  // 最外层自适应div高度即为表格高度 如表格是最外层则通过计算设置
  const children = container.children
  let height = document.getElementById('app').offsetHeight
  for (const child of children) {
    if (child.classList.contains('table')) {
      height = getComputedMargin(child)
    }
  }
  this.$nextTick(() => {
    this.tableHeight = height - 20
  })
}
// 本地字典
Vue.prototype.$dict = function (key, val = undefined) {
  let filterList = []
  if (val != undefined) {
    filterList = dictList[key].filter((i) => {
      return val == i.value
    })[0]
  } else {
    filterList = dictList[key]
  }
  return filterList
}
// 动态字典
Vue.prototype.$filterDict = function (key, list, number = 'number') {
  let filterList = []
  if (key) {
    filterList = list.filter((i) => {
      return key == i[number]
    })[0]
  } else {
    filterList = ''
  }
  return filterList
}
// 日期格式化
Vue.prototype.$formatDate = function (val, num = 16) {
  return val ? val.replace('T', ' ').slice(0, num) : ''
}
// 复制文本
Vue.prototype.$copyFn = function (t) {
  var input = document.createElement('input')
  input.value = t
  document.body.appendChild(input)
  input.select()
  document.execCommand('Copy')
  document.body.removeChild(input)
}
// 图片转base64
Vue.prototype.$toBase64 = function (file, callback) {
  let reader = new FileReader()
  reader.onload = (e) => {
    let data = {
      fileName: file.name,
      imagesBase64: e.target.result,
      filetype: 'image',
      keyName: new Date().getTime(),
      ticket: undefined,
    }
    callback(data)
  }
  reader.readAsDataURL(file)
}
// 线上图片转base64
Vue.prototype.$getbase64 = function (filePath, callback = undefined) {
  baseApi
    .getbase64({
      filePath,
    })
    .then((res) => {
      callback && callback('data:image/png;base64,' + res.data)
    })
    .catch((err) => {
      this.$message.error(err.error)
    })
}
// 微信支付
Vue.prototype.$pay = function (val) {
  var userAgent = navigator.userAgent.toLowerCase()
  if (
    !/iphone|ipad|ipod|android|webos|blackberry|iemobile|opera mini/i.test(
      userAgent
    )
  ) {
    this.$message({
      message: '请在手机端进行充值操作',
      type: 'warning',
    })
    return
  }
  baseApi
    .pay(val)
    .then((res) => {
      let out_trade_notemp = res.data.out_trade_notemp
      let this_ = this
      function onBridgeReady() {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          res.data.objsign,
          function (res) {
            if (res.err_msg == 'get_brand_wcpay_request:ok') {
              this_.$message({
                message: '支付成功',
                type: 'success',
              })
              this_.$store.commit('viewLoading', true)
              // 轮询状态
              let timer = setInterval(() => {
                baseApi
                  .getpay({ outtradeno: out_trade_notemp })
                  .then((res) => {
                    this_.$store.commit('viewLoading', false)
                    clearInterval(timer)
                    this_.$getuserbindInfo(() => {
                      location.reload()
                    })
                  })
                  .catch((err) => {})
              }, 1000)
            }
          }
        )
      }
      if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
        }
      } else {
        onBridgeReady()
      }
    })
    .catch((err) => {
      this.$message.error(err.error)
    })
}
// 购买线索
Vue.prototype.$buyBusiness = function (item, isAll = false) {
  let expendAmount = isAll ? item.remainingAmount : Number(item.sellPrice)
  let tips = isAll
    ? `本次消费<span> ${this.$amountFormat(
        expendAmount
      )} </span>元, 确认买断此条线索?`
    : `本次消费<span> ${this.$amountFormat(
        expendAmount
      )} </span>元, 确认接单此条线索?`
  this.$store.commit('confirmBuy', {
    show: true,
    params: {
      inquiryId: item.id, // 线索ID
      expendAmount, // 购买金额
      acceptNum: isAll ? item.remainingNum : 1, // 购买数量
      rechargeCategory: 1,
      orderdesc: '购买线索',
      memberShipLevelId: undefined, // vip时传
      openid: this.$store.state.accountInfo.openid,
      rechargePurchasePointTotal: undefined,
      tips,
      success: isAll ? '线索买断成功!' : '线索接单成功!',
    },
  })
}
// 购买会员
Vue.prototype.$buyVip = function (item) {
  this.$store.commit('confirmBuy', {
    show: true,
    params: {
      expendAmount: item.price,
      acceptNum: 1,
      rechargeCategory: 1,
      orderdesc: '购买会员',
      memberShipLevelId: item.id,
      openid: this.$store.state.accountInfo.openid,
      rechargePurchasePointTotal: undefined,
      tips: `本次消费<span> ${this.$amountFormat(
        item.price
      )} </span>元, 确认开通 <span>会员${item.grade}</span> ?`,
      success: `会员${item.grade}开通成功`,
    },
  })
}
// 新增消费记录
Vue.prototype.$addpurchaserecord = function (params) {
  baseApi
    .addpurchaserecord(params)
    .then((res) => {
      this.$message({
        message: params.success,
        type: 'success',
      })
      this.$store.commit('confirmBuy', {
        show: false,
        params: {},
      })
      this.$getuserbindInfo(() => {
        window.location.href = this.$removeQueryParameter(location.href, 'code')
      })
    })
    .catch((err) => {
      this.$message.error(err.error)
    })
}
// 金额格式化
Vue.prototype.$amountFormat = function (num) {
  var result = parseFloat(num)
  if (isNaN(result)) {
    return ''
  }
  var s_x = result.toFixed(2)
  return s_x
}
// 打开微信客服
Vue.prototype.$openHelp = function () {
  open('https://work.weixin.qq.com/kfid/kfc84242050328ce806')
}
// 授权
Vue.prototype.$shareFn = function (redirectUri, callback = undefined) {
  const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx86aef3445f200f66&redirect_uri=${encodeURIComponent(
    redirectUri
  )}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
  window.location.href = authUrl
}
// 删除地址参数
Vue.prototype.$removeQueryParameter = function (url, parameterToRemove) {
  var urlParts = url.split('?')
  var baseUrl = urlParts.shift()
  var queryParams = urlParts.join('?').split('&')

  var newQueryParams = []
  queryParams.forEach(function (queryParam) {
    var [key, value] = queryParam.split('=')
    if (key !== parameterToRemove) {
      newQueryParams.push(queryParam)
    }
  })
  var newUrl = baseUrl
  if (newQueryParams.length) {
    newUrl += '?' + newQueryParams.join('&')
  }
  return newUrl
}
// 验证是否过期
Vue.prototype.$isExpired = function (dateString) {
  try {
    const targetDate = new Date(dateString).getTime() + 2592000000
    const now = new Date().getTime()
    return now > targetDate
  } catch {
    return true
  }
}
// ------------------------------------权限验证-------------------------------------------
Vue.prototype.$getInfo = function (callback = undefined) {
  this.$store.state.viewLoading = true
  this.$getproductSet(true)
  // 判断openId 是否存在
  if (this.$store.state.accountInfo.openid) {
    this.$store.state.viewLoading = false
    callback && callback()
    this.$createPersonalCode()
    this.$setAccountInfo()
    this.$setShare()
  } else {
    // 判断URL中是否存在 code
    if (this.$route.query.code) {
      baseApi
        .getuserinfo({
          appid: 'wx86aef3445f200f66',
          code: this.$route.query.code,
        })
        .then((res) => {
          this.$store.commit('accountInfo', res.data)
          this.$store.state.viewLoading = false
          this.$getuserbindInfo(() => {
            // 判断是否授权
            if (this.$store.state.accountInfo.errcode == 0) {
              // 没注册 跳转注册页面 并自动默认注册
              if (res.data.infos.id == 0) {
                // 判断是否存在邀请码  如有则注册绑定
                let personalCode = undefined
                try {
                  if (
                    Object.prototype.toString.call(
                      this.$route.query.personalCode
                    ) === '[object Array]'
                  ) {
                    personalCode = this.$route.query.personalCode[0]
                  } else {
                    personalCode = this.$route.query.personalCode
                      ? this.$route.query.personalCode.trim()
                      : undefined
                  }
                } catch {}

                accountInfoApi
                  .saveuserinfo({
                    openid: this.$store.state.accountInfo.openid,
                    InvitationCode: personalCode,
                  })
                  .then((res) => {
                    try {
                      this.$getuserinfobyopenid()
                      if (this.$route.fullPath != '/share') {
                        this.$router.push({ path: '/accountInfo' })
                        this.$message({
                          message: '请您绑定账户信息',
                          type: 'warning',
                        })
                      }
                    } catch {}
                  })
                  .catch((err) => {
                    this.$message.error(err.error)
                  })
              } else {
                callback && callback()
                this.$setAccountInfo()
              }
            } else {
              // 没授权 打开授权功能
              this.$store.commit('empowerParams', {
                empowerShow: true,
              })
            }
          })
        })
        .catch((err) => {
          this.$store.state.viewLoading = false
          if (err.error == '退出重试') {
            location.href = this.$removeQueryParameter(location.href, 'code')
          }
          // this.$message.error(err.error)
        })
    } else if (this.$route.query.openid) {
      this.$store.state.viewLoading = false
      // 属于推送情况
      this.$getuserinfobyopenid(callback)
    } else {
      // 微信网页进入
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx86aef3445f200f66&redirect_uri=${encodeURIComponent(
        location.href
      )}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
    }
  }
}
// 通过openId获取到数据
Vue.prototype.$getuserinfobyopenid = function (callback = undefined) {
  let openid = this.$route.query.openid || this.$store.state.accountInfo.openid
  baseApi
    .getuserinfobyopenid({ openid })
    .then((res) => {
      this.$store.commit('accountInfo', res.data)
      this.$getuserbindInfo(() => {
        // 检测用户禁用
        if (this.$store.state.accountInfo.isForbidden) {
          this.$router.replace({ path: '/isForbidden' })
        } else {
          callback && callback(res)
          this.$getproductSet(false)
          this.$setShare()
        }
      })
    })
    .catch((err) => {
      this.$message.error(err.error)
    })
}
// 获取用户信息
Vue.prototype.$getuserbindInfo = function (callback = undefined) {
  if (this.$store.state.accountInfo.openid) {
    baseApi
      .getuserbindInfo({ openid: this.$store.state.accountInfo.openid })
      .then((res) => {
        if (res.data.membershipLevelName) {
          let levelName = res.data.membershipLevelName
          if (levelName == 'V1' || levelName == 'V2' || levelName == 'V3') {
            res.data.levelImg = require(`@/assets/images/account/${levelName}.png`)
          } else {
            res.data.levelImg = ''
          }
        }
        this.$store.commit('accountInfo', res.data)
        callback && callback()
      })
      .catch((err) => {
        this.$message.error(err.error)
      })
  }
}
// 生成邀请码
Vue.prototype.$createPersonalCode = function (callback = undefined) {
  if (this.$store.state.accountInfo.openid) {
    if (!this.$store.state.accountInfo.personalCode) {
      baseApi
        .createPersonalCode({ openId: this.$store.state.accountInfo.openid })
        .then((res) => {
          this.$getuserbindInfo(() => {
            this.$createPersonalCode()
          })
        })
        .catch((err) => {
          this.$message.error(err.error)
        })
    } else if (
      !this.$store.state.accountInfo.qrTicket ||
      this.$isExpired(this.$store.state.accountInfo.qrAddTime)
    ) {
      let params = {
        appid: 'wx86aef3445f200f66',
        scene_str: this.$store.state.accountInfo.personalCode,
        openid: this.$store.state.accountInfo.openid,
      }
      baseApi
        .createQR(params)
        .then((res) => {
          this.$getuserbindInfo()
        })
        .catch((err) => {
          this.$message.error(err.error)
        })
    }
  }
}
// 获取项目图片
Vue.prototype.$getproductSet = function (type = false, callback = undefined) {
  let openid = this.$store.state.accountInfo.openid || undefined
  baseApi
    .getproductSet({ appid: 'wx86aef3445f200f66', openid })
    .then((res) => {
      if (type) {
        delete res.data.isFollowOfficialAccount
      }
      if (res.data.shareBusinessbgBase64) {
        res.data.shareBusinessbgBase64 = `data:image/png;base64,${res.data.shareBusinessbgBase64}`
      }
      this.$store.commit('accountInfo', res.data)
      callback && callback()
    })
    .catch((err) => {
      this.$message.error(err.error)
    })
}
// 设置时间
Vue.prototype.$formatRelativeTime = function (dateTimeString) {
  const now = new Date()
  const targetTime = new Date(dateTimeString)
  const diffInMilliseconds = now - targetTime
  const diffInSeconds = diffInMilliseconds / 1000
  const diffInMinutes = diffInSeconds / 60
  const diffInHours = diffInMinutes / 60
  const diffInDays = diffInHours / 24
  if (diffInMinutes < 5) {
    return '刚刚'
  } else if (diffInHours < 1) {
    return `${Math.floor(diffInMinutes)} 分钟前`
  } else if (diffInHours < 6) {
    return `${Math.floor(diffInHours)} 小时前`
  } else if (diffInDays < 2) {
    return '1 天前'
  } else {
    return `${Math.floor(diffInDays)} 天前`
  }
}
// 检测是否设置用户名及手机号
Vue.prototype.$setAccountInfo = function () {
  this.$getuserinfobyopenid(() => {
    if (
      !this.$store.state.accountInfo.infos.realName ||
      !this.$store.state.accountInfo.infos.telPhone
    ) {
      if (
        this.$route.fullPath != '/accountInfo' &&
        this.$route.fullPath != '/share'
      ) {
        this.$store.state.setAccountInfo = true
      }
    }
  })
}
// 设置全局分享
Vue.prototype.$setShare = function () {
  if (this.$store.state.accountInfo.personalCode) {
    let url = location.href
    let link = this.$removeQueryParameter(location.href, 'code')
    link = this.$removeQueryParameter(link, 'personalCode')
    link = this.$removeQueryParameter(link, 'qrTicket')
    link = this.$removeQueryParameter(link, 'ticket')
    if (location.href.indexOf('?') != -1) {
      link = `${location.href}&personalCode=${this.$store.state.accountInfo.personalCode}`
    } else {
      link = `${location.href}?&personalCode=${this.$store.state.accountInfo.personalCode}`
    }
    let agent = navigator.userAgent.toLowerCase()
    if (agent.indexOf('iphone') >= 0 || agent.indexOf('ipad') >= 0) {
      url = this.$store.state.accountInfo.realAuthUrl
    }
    baseApi
      .getsigndata({
        url,
      })
      .then((res) => {
        wx.config({
          debug: false,
          appId: res.data.appId,
          timestamp: res.data.timestamp,
          nonceStr: res.data.nonceStr,
          signature: res.data.signature,
          jsApiList: ['updateAppMessageShareData'],
        })
        wx.ready(() => {
          wx.updateAppMessageShareData({
            title: '运营猫商机领航',
            desc: this.$store.state.accountInfo.inviteContent,
            link,
            imgUrl: this.$store.state.accountInfo.inviteLogo,
            success: function () {},
          })
        })
        wx.error((res) => {})
      })
      .catch((err) => {})
  }
}
// ------------------------------------图片上传-------------------------------------------
// 上传图片
Vue.prototype.$beforeUploadImg = function (val, list) {
  this.$toBase64(val, (res) => {
    appealApi
      .uploadImage(res)
      .then((res) => {
        this[list].push({
          url: res.data,
          name: res.fileName,
        })
        if (list == 'wechatFilePath' && this.wechatFilePath.length) {
          this.form.wechatFilePath = this.wechatFilePath[0].url
          this.$refs.phone.clearValidate()
          this.$refs.wechatNumber.clearValidate()
          this.$refs.wechatFilePath.clearValidate()
        }
      })
      .catch((err) => {
        this.$message.error(err.error)
      })
  })
}
// 删除图片
Vue.prototype.$removeImg = function (val, list) {
  this[list] = this[list].filter((i) => {
    return i.uid != val.uid
  })
  if (list == 'wechatFilePath') {
    this[list] = []
    this.form.wechatFilePath = ''
  }
}
